<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          v-if="active == 0"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="地区选择"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '请选择地区',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="申报单位"
                prop="shenbaodanwei"
                :rules="[
                { required: true, message: '请输入单位名称', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.shenbaodanwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item
                label="俱乐部名称"
                prop="danwei"
                :rules="[
                { required: true, message: '请输入俱乐部名称', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入俱乐部名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="clubleixing"
                          :rules="[
                { required: true, message: '请选择俱乐部类型', trigger: 'blur' },
              ]"
            >
              <el-radio-group v-model="formData.clubleixing">
                <el-radio :label="'社会俱乐部'">社会俱乐部</el-radio>
                <el-radio :label="'学校俱乐部'">学校俱乐部</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">


          <el-col :span="12">
            <el-form-item label="申报等级" prop="bgrade">
              <el-radio-group v-model="formData.bgrade">
                <el-radio :label="'一星'">一星</el-radio>
                <!--                <el-radio :label="'学校俱乐部'">学校俱乐部</el-radio>-->
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="场地面积"
                prop="chandimianji"
                :rules="[
                { required: true, message: '场地面积不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.chandimianji"
                  type="text"
                  placeholder="请输入场地面积（平米）"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="拟注册运动员人数"
                prop="yundongyuanrenshu"
                :rules="[
                { required: true, message: '人数不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.yundongyuanrenshu"
                  type="number"
                  placeholder="请输入人数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="详细地址"
                prop="address"
                :rules="[
                { required: true, message: '请输入详细地址', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.address"
                  type="text"
                  placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="场地照片" prop="changdipic">
              <PicUploader :fileList="formData.changdipic" :limit="5"></PicUploader>
              <div class="form-label-desc">上传5张场地照片</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>负责联系人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="姓名"
                prop="nickname"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.nickname"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="身份证号"
                prop="certificatenumber"
                :rules="[
                { required: true, validator: validator.idCard,message:'请输入正确的身份证号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.certificatenumber"
                  type="text"
                  placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="phone"
                :rules="[
                { required: true, validator: validator.phone,message:'请输入正确的手机号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  type="text"
                  placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>日常联系人信息</el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item
                label="姓名"
                prop="contactsname"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.contactsname"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="身份证号"
                prop="contactscertificatenumber"
                :rules="[
                { required: true, validator: validator.idCard,message:'请输入正确的身份证号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.contactscertificatenumber"
                  type="text"
                  placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="邮箱"
                prop="contactsemail"
                :rules="[
                { required: true, validator: validator.email,message:'请输入正确的邮箱', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.contactsemail"
                  type="text"
                  placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="contactsphone"
                :rules="[
                { required: true, validator: validator.phone,message:'请输入正确的手机号', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                  v-model="formData.contactsphone"
                  type="text"
                  placeholder="请输入手机"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交申请</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <div class="step-two" v-if="active == 1">
        <ul class="step-two-box">
          <li>提交申报信息成功！</li>
          <li>审核工作会在24小时内完成。</li>
        </ul>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="fetch">我知道了</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="step-three" v-if="active == 2">
        <div class="step-three-title">审核成功</div>
        <div class="step-three-text">
          <div class="step-three-li">您已获得</div>
          <div class="step-three-li">全国啦啦操一星俱乐部授权</div>
          <div class="step-three-li">全国啦啦操七彩星级指定考级点授权</div>
        </div>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="onSubmitThree">前往主页</el-button>
          </el-col>
        </el-row>
      </div>
      <van-dialog v-model="showPay" title="收款账户" :show-confirm-button="false" :close-on-click-overlay="true">
        <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px;">
          <img style="width: 100%;" src=""/>
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round @click="onPayDownload">下载二维码
          </van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<style scoped>
.step-box {
  margin: 0 .2rem .2rem;
}

.step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: 15px;
}


.step-three-title {
  font-size: 24px;
  padding: .3rem 0;
  text-align: center;
}

.step-three-text {
  margin: 0 .3rem;
  font-size: 14px;
}

.step-three-danwei {
  margin: .1rem 0 .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubApplyMine',
  components: {
    PicUploader, FileUploader
  },
  data: function () {
    return {
      validator,
      active: 0,
      loading: false,
      showPay: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
        bgrade: '一星',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
        shenbaozip: [],
        yanshoubiao_pic: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = "俱乐部申请"
    this.getAreaOptions()
//            if(that.formData.id){
    this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {
            if (that.formData.changdipic.length != 5) {
              that.$message.warning('请上传5张场地照片');
              return
            }
            if (that.formData.shenbaozip.length == 0) {
              // that.$message.warning('请上传申报表');
              // return
            }
            if (!that.formData.bgrade) {
              that.$message.warning('请选择等级');
              return
            }
            if (!that.formData.clubleixing) {
              that.$message.warning('请选择俱乐部类型');
              return
            }
            if (!this.formData.area) {
              that.$message.warning('请选择地区');
              return
            }
          }
          that.saveLoading = true;
          that.$api.post('/api/club/apply', that.formData, (res) => {
            that.saveLoading = false;

            // 跳转改为步骤条进行
            that.active = 1
            return
            rbLink({
              name: "CertClubResult",
              query: {
                id: res.data.id
              }
            }, 'replace')
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (that.formData.changdipic.length != 5) {
          Toast('请上传5张场地照片');
          return
        }
        if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        }
        if (!that.formData.bgrade) {
          Toast('请选择等级');
          return
        }
        if (!that.formData.clubleixing) {
          Toast('请选择俱乐部类型');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {

        that.$api.post('/api/club/apply', that.formData, (res) => {
          that.saveLoading = false;

          // 跳转改为步骤条进行
          that.active = 1
          return
          rbLink({
            name: "CertClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onPayDownload() {
      this.download({
        name: '啦啦操收款二维码',
        url: ''
      })
    },

    download(file) {
      appEvent({
        name: 'downloadFile',
        query: {
          name: file.name,
          url: file.url,
        }
      });
    },

    onSubmitThree(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;

      console.log(that.formData, that.submitThreeType)

      // 回到俱乐部详情页面
      rbLink({
        name: 'ClubDetail',
        query: {
          id: that.formData.id
        }
      }, 'replace')
      return

      if (that.submitThreeType == 'show') return
      that.formValidate = true;


      for (let field in that.formData) {

        if (that.formData.changdipic.length != 5) {
          Toast('请上传5张场地照片');
          return
        }
        if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        }
        if (!that.formData.bgrade) {
          Toast('请选择等级');
          return
        }
        if (!that.formData.clubleixing) {
          Toast('请选择俱乐部类型');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/club/yanshouSave', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')

        rbLink({
          name: "ClubIndex",
        }, 'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })

    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

    // 我要付款
    onPay() {
      this.submitThreeType = 'show'
      this.showPay = true
    },
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit'
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/clubdetail', {
        id: that.formData.id
      }, (res) => {
        that.loading = true
        that.formData = res.data;
        if (res.data.registstatus == 1) {
          that.active = 1;
          return;
          rbLink({
            name: "ClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        } else if (res.data.registstatus == 2) {
          that.active = 2;
        }
      }, (res) => {
        that.loading = true
//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// ClubApplyMine.vue?9d1936ea